import { observer } from "mobx-react";
import React, { Component } from "react";
import FilterGroup from "../FilterGroup";
import TextInput from "../../form/TextInput";

class ShiftFilter extends Component {
  render() {
    const { store } = this.props;

    return (
      <FilterGroup title="Shift">
          <TextInput
            errorMessage="must be a number"
            onChangeHandler={store.updateShiftBoundary}
            hasError={store.errors.shiftBoundary}
            label="Boundary"
            value={store.shiftBoundary}
          />
          <TextInput
            errorMessage="must be a number"
            onChangeHandler={store.updateShiftStep}
            hasError={store.errors.shiftStep}
            label="Step"
            value={store.shiftStep}
          />
        </FilterGroup>
    );
  }
}

export default observer(ShiftFilter);



// WEBPACK FOOTER //
// ./src/components/filters/options/ShiftFilter.js